<template>
  <div class="flex flex-col gap-6 justify-items-center items-center">
    <Typography size="main-xl" class="text-center leading-none text-nowrap">Claim your final badge!</Typography>
    <img src="https://albarra.world/cms/assets/11747447-9182-437b-ba03-79cf35582456" alt="" style="max-width: 350px;margin: 0% auto;">
    <div class="w-1/6 h-[0.25rem] bg-red-500 mx-auto"></div>
    <span class="flex flex-col gap-2">
      <Typography size="secondary-book" class="text-center">Airdrop wallet set, thank you for choppin' with me fren! Claim this final Albarra "On-chain" badge and share it on X</Typography>
    </span>
  <div class="flex flex-col gap-3 items-center">
    <Button v-if="!showShare"
            @click="onClickClaim"
            class="h-16 px-24 bg-primary font-bold flex items-center justify-center gap-4">
        <span style="font-size: 36px; font-family: Ravenholm;font-weight: normal !important;">Claim Badge</span>
    </Button>

    <Button v-if="showShare"
            @click="onClickShare"
            class="h-16 px-24 bg-primary hover:bg-primary font-bold flex items-center justify-center gap-3">
      <span style="font-size: 36px; font-family: Ravenholm;font-weight: normal !important;">Share on </span>
      <img src="/x.svg" alt="X" class="w-5 h-5" />
    </Button>
  </div>
  </div>
</template>

<script setup>
import Typography from "@/components/common/Typography.vue"
import { cmsStore } from "../../stores/cmsStore";
import { useModalsStore } from '../../stores/useModalsStore'
import { ref } from 'vue'

const modalsStore = useModalsStore()

const cms = cmsStore();
const showShare = ref(false)

const onClickClaim = () => {
  const BADGE_ID = modalsStore.modalPayload.badge_id
  cms.userHasBadge(BADGE_ID)
     .then(response => {
        if (response.code === 'success-badge-assigned-now') {
          // No cerrar ni redirigir. Mostrar botón para compartir en X.
          showShare.value = true
        }
     })
}

const closeModal = () => {
  modalsStore.closeModal()
  navigateTo('/badges')
}

const onClickShare = () => {
  const text = encodeURIComponent('I just set my wallet in albarra.world to receive the airdrop of my @albarra_tdrc pilot season rewards! 🪵🪓')
  const url = `https://twitter.com/intent/tweet?text=${text}`
  window.open(url, '_blank')
  modalsStore.closeModal()
}
</script>

<style scoped>
</style>
